"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const t = __importStar(require("io-ts"));
const graphql_1 = require("graphql");
const language_1 = require("graphql/language");
const luxon_1 = require("luxon");
exports.ISODate = t.brand(t.string, (s) => {
    const dateTime = luxon_1.DateTime.fromFormat(s, "yyyy-MM-dd");
    return dateTime.isValid;
}, "DateString");
const parseDateString = (str) => {
    const decoded = exports.ISODate.decode(str);
    if (decoded._tag === "Left") {
        throw new Error(`${str} is not on format YYYY-MM-DD`);
    }
    return decoded.right;
};
exports.ISODateResolver = new graphql_1.GraphQLScalarType({
    name: "ISODate",
    description: "ISO date string (YYYY-MM-DD)",
    parseValue: parseDateString,
    serialize: (x) => x,
    parseLiteral: (ast) => {
        if (ast.kind === language_1.Kind.STRING) {
            return parseDateString(ast.value);
        }
        return null;
    },
});
